import axios from 'axios'

export default {
    namespaced: true,
    state: {
        newCount: null,
        allCount: null,
        counties: [],
        sizes: [],
        options: [],
        states: [],
		preffered_time: [],
		preffered_contact: [],
        how_did_hear: [],
        leads: [],
        estimators: [],
        status_array: [],
        schedules_array: [],
        confirmations_array: [],
        assign_array: [],
        shapes: []
    },
    getters: {
        newCount (state) {
            return state.newCount
        },
        allCount (state) {
            return state.allCount
        },
        counties (state) {
            return state.counties
        },
        sizes (state) {
            return state.sizes
        },
        options (state) {
            return state.options
        },
        filteredOptions (state) {
            return state.options.filter(option => {
                return option.required != "Yes"
            })
        },
        requiredOptions (state) {
            return state.options.filter(option => {
                return option.required == "Yes"
            })
        },
        requiredTotal (state) {
            var sum = 0
            state.options.forEach(option => {
                if(option.required == 'Yes')
                    sum += parseFloat(option.price)
            });
            return sum
        },
        states (state) {
            return state.states
        },
		preffered_time (state) {
			return state.preffered_time
		},
		preffered_contact (state) {
			return state.preffered_contact
		},
		how_did_hear (state) {
			return state.how_did_hear
        },
        leads (state) {
            return state.leads
        },
        estimators (state) {
            return state.estimators
        },
        statusArray (state) {
            return state.status_array
        },
        schedulesArray (state) {
            return state.schedules_array
        },
        confirmationsArray (state) {
            return state.confirmations_array
        },
        assignArray (state) {
            return state.assign_array
        },
        shapes (state) {
            return state.shapes
        },
    },
    mutations: {
        SET_NEW_COUNT(state, payload) {
            state.newCount = payload
        },
        SET_ALL_COUNT(state, payload) {
            state.allCount = payload
        },
        SET_COUNTIES(state, payload) {
            state.counties = payload
        },
        SET_SIZES(state, payload) {
            state.sizes = payload
        },
        SET_OPTIONS(state, payload) {
            state.options = payload
        },
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_PREFFRED(state, payload) {
            return state.preffered_time = payload
		},
        SET_PREFFRED_CONTACT(state, payload) {
            return state.preffered_contact = payload
		},
        SET_HOW(state, payload) {
            return state.how_did_hear = payload
        },
        SET_LEADS(state, payload) {
            return state.leads = payload
        },
        SET_ESTIMATORS(state, payload) {
            return state.estimators = payload
        },
        SET_STATUS_ARR(state, payload) {
            return state.status_array = payload
        },
        SET_SCHEDULES_ARR(state, payload) {
            return state.schedules_array = payload
        },
        SET_CONFIRMATION_ARR(state, payload) {
            return state.confirmations_array = payload
        },
        SET_ASSIGN_ARR(state, payload) {
            return state.assign_array = payload
        },
        SET_SHAPES(state, payload) {
            state.shapes = payload
        },
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('estimator/data')
            commit('SET_NEW_COUNT', response.data.data.new_count)
            commit('SET_ALL_COUNT', response.data.data.total_count)
            commit('SET_COUNTIES', response.data.data.counties)
            commit('SET_SIZES', response.data.data.sizes)
            commit('SET_OPTIONS', response.data.data.options)
            commit('SET_STATES', response.data.data.states)
            commit('SET_PREFFRED', response.data.data.preffered_time)
            commit('SET_PREFFRED_CONTACT', response.data.data.preffered_contact)
            commit('SET_HOW', response.data.data.how_did_hear)
            commit('SET_ESTIMATORS', response.data.data.estimators)        
            commit('SET_STATUS_ARR', response.data.data.status_array)
            commit('SET_SCHEDULES_ARR', response.data.data.schedules_array)
            commit('SET_CONFIRMATION_ARR', response.data.data.confirmations_array)
            commit('SET_ASSIGN_ARR', response.data.data.assign_array)
            commit('SET_SHAPES', response.data.data.shapes)
        },
        async addLead( { dispatch }, data) {
            let response = await axios.post('estimator/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateLead( { dispatch }, data) {
            let response = await axios.post('estimator/update', data)
            await dispatch('getData')
            return response.data
        },
        async addComment(_, data) {
            let response = await axios.post('estimator/comment', data)        
            return response.data
        },
        async scheduleEstimator(_, data) {
            let response = await axios.post('estimator/schedule', data)
            return response.data.status
        },
        async newEmail(_, data) {
            let response = await axios.post('estimator/email', data)        
            return response.data
        },
    }
}